const isElectron = typeof window !== 'undefined' && !!window.electronAPI

if (!isElectron) {
  console.warn('[API] 非 Electron 环境，请在 Electron 窗口中操作')
}

function getAuthUser() {
  try { return JSON.parse(sessionStorage.getItem('auth_user') || 'null') } catch (e) { return null }
}

const api = {
  isElectron,

  getAccounts: () =>
    isElectron ? window.electronAPI.invoke('accounts:list') : Promise.resolve([]),

  getAccount: (id) =>
    isElectron ? window.electronAPI.invoke('accounts:get', id) : Promise.resolve(null),

  createAccount: (data) =>
    isElectron ? window.electronAPI.invoke('accounts:create', { ...(data || {}), auth_user: getAuthUser() }) : Promise.reject(new Error('请在 Electron 窗口中操作')),

  beginAccountLogin: (data) =>
    isElectron ? window.electronAPI.invoke('accounts:begin-login', { ...(data || {}), auth_user: getAuthUser() }) : Promise.reject(new Error('请在 Electron 窗口中操作')),

  deleteAccount: (id) =>
    isElectron ? window.electronAPI.invoke('accounts:delete', { id, auth_user: getAuthUser() }) : Promise.resolve({ success: false }),

  batchDeleteAccounts: (ids) =>
    isElectron ? window.electronAPI.invoke('accounts:batch-delete', { ids, auth_user: getAuthUser() }) : Promise.resolve({ success: false }),

  batchMoveAccounts: (account_ids, group_id) =>
    isElectron ? window.electronAPI.invoke('accounts:batch-move', { account_ids, group_id, auth_user: getAuthUser() }) : Promise.resolve({ success: false }),

  updateAccount: (data) =>
    isElectron ? window.electronAPI.invoke('accounts:update', { ...(data || {}), auth_user: getAuthUser() }) : Promise.resolve(null),

  moveAccount: (account_id, direction) =>
    isElectron ? window.electronAPI.invoke('accounts:move', { account_id, direction, auth_user: getAuthUser() }) : Promise.resolve([]),

  reLogin: (id) =>
    isElectron ? window.electronAPI.invoke('accounts:login', { id, auth_user: getAuthUser() }) : Promise.reject(new Error('请在 Electron 窗口中操作')),

  refreshProfile: (id) =>
    isElectron ? window.electronAPI.invoke('accounts:refresh-profile', { id, auth_user: getAuthUser() }) : Promise.reject(new Error('请在 Electron 窗口中操作')),

  getGroups: () =>
    isElectron ? window.electronAPI.invoke('groups:list') : Promise.resolve([]),

  createGroup: (name) =>
    isElectron ? window.electronAPI.invoke('groups:create', name) : Promise.reject(new Error('请在 Electron 窗口中操作')),

  deleteGroup: (id) =>
    isElectron ? window.electronAPI.invoke('groups:delete', id) : Promise.resolve({ success: false }),

  updateGroup: (data) =>
    isElectron ? window.electronAPI.invoke('groups:update', data) : Promise.resolve([]),

  getGroupCollapseState: () =>
    isElectron ? window.electronAPI.invoke('groups:collapse-state') : Promise.resolve({}),

  setGroupCollapse: (group_id, collapsed) =>
    isElectron ? window.electronAPI.invoke('groups:set-collapse', { group_id, collapsed }) : Promise.resolve(),

  getPreviewUrl: (accountId) =>
    isElectron ? window.electronAPI.invoke('preview:get-url', accountId) : Promise.resolve(null),

  getPlatforms: () =>
    isElectron ? window.electronAPI.invoke('platforms:list') : Promise.resolve([
      { key: 'douyin', name: '抖音' }, { key: 'kuaishou', name: '快手' },
      { key: 'xiaohongshu', name: '小红书' }, { key: 'weibo', name: '微博' },
      { key: 'bilibili', name: 'B站' }, { key: 'shipinhao', name: '视频号' },
      { key: 'jinritoutiao', name: '头条' }
    ]),

  getFingerprintInfo: () =>
    isElectron ? window.electronAPI.invoke('fingerprints:info') : Promise.resolve({ total: 20, used: 0, available: 20 }),

  heartbeat: (accountId) =>
    isElectron ? window.electronAPI.invoke('accounts:heartbeat', accountId) : Promise.resolve({ alive: false }),

  listPublishTasks: () =>
    isElectron ? window.electronAPI.invoke('publish:tasks:list') : Promise.resolve({ tasks: [], config: { threadMode: 'single', executionStrategy: 'cycle', minAccountIntervalSeconds: 30 }, running: false }),

  createPreviewPublishTasks: (data) => {
    const authUser = getAuthUser()
    const payload = { ...(data || {}), auth_user: authUser }
    return isElectron ? window.electronAPI.invoke('publish:tasks:create-preview', payload) : Promise.resolve({ success: true, tasks: [], user: authUser })
  },

  updatePublishConfig: (config) =>
    isElectron ? window.electronAPI.invoke('publish:config:update', config) : Promise.resolve({ success: true, config }),

  startPublishTasks: () =>
    isElectron ? window.electronAPI.invoke('publish:tasks:start', { auth_user: getAuthUser() }) : Promise.resolve({ success: true }),

  startPublishTask: (task_id) =>
    isElectron ? window.electronAPI.invoke('publish:tasks:start-one', { task_id, auth_user: getAuthUser() }) : Promise.resolve({ success: true }),

  pauseAllPublishTasks: () =>
    isElectron ? window.electronAPI.invoke('publish:tasks:pause-all') : Promise.resolve({ success: true }),

  updatePublishTaskStatus: (task_id, status) =>
    isElectron ? window.electronAPI.invoke('publish:tasks:update-status', { task_id, status }) : Promise.resolve({ success: true }),

  setPublishBrowserVisibility: ({ task_id, visible, all = false }) =>
    isElectron ? window.electronAPI.invoke('publish:tasks:set-browser-visibility', { task_id, visible, all }) : Promise.resolve({ success: true }),

  refreshPublishTaskStatus: () =>
    isElectron ? window.electronAPI.invoke('publish:tasks:refresh-status') : Promise.resolve({ success: true, tasks: [] }),

  getPublishSettings: (scope, id) =>
    isElectron ? window.electronAPI.invoke('publish:settings:get', { scope, id }) : Promise.resolve(null),

  savePublishSettings: (scope, id, settings) =>
    isElectron ? window.electronAPI.invoke('publish:settings:save', { scope, id, settings }) : Promise.resolve({ success: true }),

  selectDirectory: () =>
    isElectron ? window.electronAPI.invoke('dialog:select-directory') : Promise.resolve({ canceled: true, path: '' }),

  selectFile: (options) =>
    isElectron ? window.electronAPI.invoke('dialog:select-file', options || {}) : Promise.resolve({ canceled: true, path: '' }),

  readFileAsBase64: (filePath) =>
    isElectron ? window.electronAPI.invoke('fs:read-file-base64', filePath) : Promise.resolve({ ok: false }),

  getAppConfig: () =>
    isElectron ? window.electronAPI.invoke('app:config:get') : Promise.resolve({ appName: '', appLogo: '' }),

  saveAppConfig: (config) =>
    isElectron ? window.electronAPI.invoke('app:config:save', config) : Promise.resolve({ ok: false }),

  // 粉丝互动 - 话术库
  listTemplates: () =>
    isElectron ? window.electronAPI.invoke('interaction:templates:list') : Promise.resolve({ templates: [], groups: [] }),
  saveTemplate: (template) =>
    isElectron ? window.electronAPI.invoke('interaction:templates:save', template) : Promise.resolve({ success: false }),
  deleteTemplate: (template_id) =>
    isElectron ? window.electronAPI.invoke('interaction:templates:delete', template_id) : Promise.resolve({ success: false }),
  manageTemplateGroups: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:templates:groups', payload) : Promise.resolve({ success: false, groups: [] }),
  importTemplates: (templates) =>
    isElectron ? window.electronAPI.invoke('interaction:templates:import', templates) : Promise.resolve({ success: false }),
  exportTemplates: () =>
    isElectron ? window.electronAPI.invoke('interaction:templates:export') : Promise.resolve({ templates: [] }),

  // 粉丝互动 - 自动回复规则
  listRules: () =>
    isElectron ? window.electronAPI.invoke('interaction:rules:list') : Promise.resolve({ rules: [] }),
  saveRule: (rule) =>
    isElectron ? window.electronAPI.invoke('interaction:rules:save', rule) : Promise.resolve({ success: false }),
  deleteRule: (rule_id) =>
    isElectron ? window.electronAPI.invoke('interaction:rules:delete', rule_id) : Promise.resolve({ success: false }),
  toggleRule: (rule_id) =>
    isElectron ? window.electronAPI.invoke('interaction:rules:toggle', rule_id) : Promise.resolve({ success: false }),

  // 粉丝互动 - 评论
  listComments: (options) =>
    isElectron ? window.electronAPI.invoke('interaction:comments:list', options) : Promise.resolve({ comments: [] }),
  replyComment: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:comments:reply', payload) : Promise.resolve({ success: false }),
  batchReplyComments: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:comments:batch-reply', payload) : Promise.resolve({ success: false }),
  likeComment: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:comments:like', payload) : Promise.resolve({ success: false }),
  deleteInteractionComment: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:comments:delete', payload) : Promise.resolve({ success: false }),

  // 粉丝互动 - 私信
  listMessages: (options) =>
    isElectron ? window.electronAPI.invoke('interaction:messages:list', options) : Promise.resolve({ messages: [] }),
  replyMessage: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:messages:reply', payload) : Promise.resolve({ success: false }),
  batchReplyMessages: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:messages:batch-reply', payload) : Promise.resolve({ success: false }),
  markMessageStatus: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:messages:mark', payload) : Promise.resolve({ success: false }),

  // 粉丝互动 - 附件管理
  listAttachments: () =>
    isElectron ? window.electronAPI.invoke('interaction:attachments:list') : Promise.resolve({ attachments: [] }),
  uploadAttachments: () =>
    isElectron ? window.electronAPI.invoke('interaction:attachments:upload') : Promise.resolve({ success: false }),
  deleteAttachment: (attachment_id) =>
    isElectron ? window.electronAPI.invoke('interaction:attachments:delete', attachment_id) : Promise.resolve({ success: false }),

  // 粉丝互动 - 看板
  getDashboardSummary: () =>
    isElectron ? window.electronAPI.invoke('interaction:dashboard:summary') : Promise.resolve({}),
  getDashboardTrend: (days) =>
    isElectron ? window.electronAPI.invoke('interaction:dashboard:trend', days) : Promise.resolve([]),

  // 数据统计 - 多平台总览
  getAnalyticsOverview: () =>
    isElectron ? window.electronAPI.invoke('analytics:overview') : Promise.resolve({}),

  // 账号监控任务
  listMonitorTasks: () =>
    isElectron ? window.electronAPI.invoke('monitor:tasks:list') : Promise.resolve({ tasks: [] }),
  createMonitorTask: (payload) =>
    isElectron ? window.electronAPI.invoke('monitor:tasks:create', payload) : Promise.resolve({ success: false }),
  updateMonitorTask: (payload) =>
    isElectron ? window.electronAPI.invoke('monitor:tasks:update', payload) : Promise.resolve({ success: false }),
  deleteMonitorTask: (task_id) =>
    isElectron ? window.electronAPI.invoke('monitor:tasks:delete', task_id) : Promise.resolve({ success: false }),

  // 数据监控 - 播放流速
  getPlayVelocity: (params) =>
    isElectron ? window.electronAPI.invoke('monitor:play-velocity', params) : Promise.resolve({ success: false }),

  // 数据监控 - 作品监控
  getWorksMonitor: (params) =>
    isElectron ? window.electronAPI.invoke('monitor:works', params) : Promise.resolve({ success: false }),

  // 数据监控 - 平台通知
  getPlatformNotify: (params) =>
    isElectron ? window.electronAPI.invoke('monitor:platform-notify', params) : Promise.resolve({ success: false }),

  // 数据监控 - 违规作品
  getViolationWorks: () =>
    isElectron ? window.electronAPI.invoke('monitor:violation-works') : Promise.resolve({ success: false }),

  // 粉丝互动 - 任务
  submitInteractionTask: (payload) =>
    isElectron ? window.electronAPI.invoke('interaction:tasks:submit', payload) : Promise.resolve({ success: false }),
  listInteractionTasks: () =>
    isElectron ? window.electronAPI.invoke('interaction:tasks:list') : Promise.resolve({ tasks: [] }),
  pauseInteractionTasks: () =>
    isElectron ? window.electronAPI.invoke('interaction:tasks:pause') : Promise.resolve({ success: false }),

  // 粉丝互动 - 自动回复引擎
  getAutoReplyStatus: () =>
    isElectron ? window.electronAPI.invoke('interaction:auto-reply:status') : Promise.resolve({ running: false }),
  startAutoReply: () =>
    isElectron ? window.electronAPI.invoke('interaction:auto-reply:start') : Promise.resolve({ success: false }),
  stopAutoReply: () =>
    isElectron ? window.electronAPI.invoke('interaction:auto-reply:stop') : Promise.resolve({ success: false }),

  downloadUpdate: (payload) =>
    isElectron ? window.electronAPI.invoke('update:download', payload) : Promise.resolve({ success: false, message: '请在 Electron 窗口中操作' }),
  openUpdateInstaller: (filePath) =>
    isElectron ? window.electronAPI.invoke('update:open-installer', filePath) : Promise.resolve({ success: false, message: '请在 Electron 窗口中操作' }),

  on: (channel, callback) => {
    if (isElectron) return window.electronAPI.on(channel, callback)
    return () => {}
  },

  // 账号代理设置
  updateAccountProxy: (accountId, proxyConfig) =>
    isElectron ? window.electronAPI.invoke('accounts:proxy:update', accountId, proxyConfig) : Promise.resolve({ success: false })
}

// ==================== 后端 API Client ====================
const LOCAL_API_BASE = isElectron ? 'http://127.0.0.1:45678' : 'https://juzhen.xmtyyzj.cn'
const AUTH_API_BASE = (() => {
  try { return localStorage.getItem('auth_server_url') || 'https://juzhen.xmtyyzj.cn' } catch (e) { return 'https://juzhen.xmtyyzj.cn' }
})()

async function apiFetch(path, options = {}, baseUrl = LOCAL_API_BASE) {
  const token = sessionStorage.getItem('auth_token')
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) }
  if (token) headers['Authorization'] = `Bearer ${token}`
  const res = await fetch(`${baseUrl}${path}`, {
    method: options.method || (options.body ? 'POST' : 'GET'),
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined
  })
  return res.json()
}

export const backend = {
  login: (username, activation_code, password, referral_code) => apiFetch('/api/auth/login', { body: { username, activation_code, password, referral_code } }, AUTH_API_BASE),
  register: (username, password, activation_code, referral_code, phone) => apiFetch('/api/auth/register', { body: { username, password, activation_code, referral_code, phone } }, AUTH_API_BASE),
  authStatus: () => apiFetch('/api/auth/profile', {}, AUTH_API_BASE),
  logout: () => Promise.resolve({ success: true }),
  renew: (activation_code) => apiFetch('/api/activation/renew', { body: { activation_code } }, AUTH_API_BASE),
  getUserProfile: () => apiFetch('/api/auth/profile', {}, AUTH_API_BASE),
  getReferralInfo: () => apiFetch('/api/referral/info'),
  registerReferral: (referral_code) => apiFetch('/api/referral/register', { body: { referral_code } }),
  createBackup: (target_path) => apiFetch('/api/backup/create', { body: { target_path } }),
  restoreBackup: (filepath) => apiFetch('/api/backup/restore', { body: { filepath } }),
  getSettings: () => apiFetch('/api/settings/config'),
  updateSettings: (data) => apiFetch('/api/settings/config/update', { body: data }),
  getOperationLogs: () => apiFetch('/api/logs/operations'),
  getAnnouncements: () => apiFetch('/api/announcements'),
  checkVersion: (current_version) => apiFetch('/api/version/check', { body: { current_version } }, AUTH_API_BASE),
  getMyTickets: () => apiFetch('/api/support/tickets'),
  createTicket: (title, content) => apiFetch('/api/support/tickets/create', { body: { title, content } }),
  replyTicket: (id, content) => apiFetch(`/api/support/tickets/${id}/reply`, { body: { content } }),
  // Admin
  adminGetUsers: () => apiFetch('/api/admin/users', {}, AUTH_API_BASE),
  adminGetUser: (id) => apiFetch(`/api/admin/users/${id}`, {}, AUTH_API_BASE),
  adminGetCodes: () => apiFetch('/api/admin/codes', {}, AUTH_API_BASE),
  adminGenerateCodes: (data) => apiFetch('/api/admin/codes/generate', { body: data }, AUTH_API_BASE),
  adminRevokeCode: (id) => apiFetch(`/api/admin/codes/${id}/revoke`, { body: {} }, AUTH_API_BASE),
  adminCreateAnnouncement: (data) => apiFetch('/api/admin/announcements/create', { body: data }),
  adminDeleteAnnouncement: (id) => apiFetch(`/api/admin/announcements/${id}/delete`, { body: {} }),
  adminUploadVersion: (data) => apiFetch('/api/admin/version/upload', { body: data }, AUTH_API_BASE),
  adminGetVersions: () => apiFetch('/api/admin/versions', {}, AUTH_API_BASE),
  adminGetTickets: () => apiFetch('/api/admin/tickets'),
  adminReplyTicket: (id, content) => apiFetch(`/api/admin/tickets/${id}/reply`, { body: { content } }),
  adminCloseTicket: (id) => apiFetch(`/api/admin/tickets/${id}/close`, { body: {} }),
  // Admin: 会员方案
  getMembershipPlans: () => apiFetch('/api/membership-plans', {}, AUTH_API_BASE),
  adminGetMembershipPlans: () => apiFetch('/api/admin/membership-plans', {}, AUTH_API_BASE),
  adminUpdateMembershipPlans: (plans) => apiFetch('/api/admin/membership-plans/update', { body: { plans } }, AUTH_API_BASE),
  // Admin: 推荐奖励配置
  adminGetReferralConfig: () => apiFetch('/api/admin/referral-config'),
  adminUpdateReferralConfig: (data) => apiFetch('/api/admin/referral-config/update', { body: data }),
  // 软件教程
  getSoftwareTutorial: () => apiFetch('/api/software/tutorial'),
  adminUpdateTutorial: (tutorial) => apiFetch('/api/admin/tutorial/update', { body: { tutorial } })
}

export default api
export { isElectron }
